module.exports = __webpack_public_path__ + "img/part4.2b3c2a26.png";